import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { Tabs, Grid, Typography, ListItem, ListItemText, Collapse, List, Chip, ExpandMore, TaskDetailDrawer, DialogFranchiseAddTask, DialogFranchiseAddInsideTask, Dialog, InfoProject, Paper, Button, makeStyles, withStyles, lighten, LinearProgress, ViewColumnIcon, Calendar, ChevronRightIcon, Create, Clear, TodayIcon, RotateLeftIcon } from "../../../../";
import uuidv1 from "uuid/v1";
import moment from "moment";

require("moment-recur");

var useStyles = makeStyles(function (theme) {
  return {
    done: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      minWidth: "150px"
    },
    doing: {
      background: theme.palette.pending.main,
      color: theme.palette.primary.contrastText,
      minWidth: "150px"
    },
    pending: {
      background: "#b7b6b682",
      color: theme.palette.error.contrastText,
      minWidth: "150px"
    },
    critical: {
      background: "#FC5F15",
      color: theme.palette.error.contrastText,
      minWidth: "150px"
    },
    outOfDate: {
      background: theme.palette.error.main,
      color: theme.palette.error.contrastText,
      minWidth: "150px"
    },
    addTaskItem: {
      border: "1px dashed " + theme.palette.primary.main,
      color: theme.palette.primary.main,
      cursor: "pointer",
      padding: "0 16px",
      minHeight: "56px"
    },
    editButton: {
      marginRight: "10px",
      borderColor: theme.palette.pending.main,
      color: theme.palette.pending.main
    },
    mr30: {
      "margin-right": "30px"
    },
    layoutOptions: {
      display: "flex",
      "justify-content": "flex-end",
      width: "97%",
      padding: "10px 0px"
    }
  };
});
var BorderLinearSuccessProgress = withStyles({
  root: {
    height: 30,
    backgroundColor: lighten("#77ffb5", 0.5),
    borderRadius: 20
  },
  bar: {
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    backgroundColor: "#77ffb5"
  }
})(LinearProgress);
var BorderLinearMediumProgress = withStyles({
  root: {
    height: 30,
    backgroundColor: lighten("#ffe082", 0.5),
    borderRadius: 20
  },
  bar: {
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    backgroundColor: "#ffe082"
  }
})(LinearProgress);
var BorderLinearIncompleteProgress = withStyles({
  root: {
    height: 30,
    backgroundColor: lighten("#E95A58", 0.5),
    borderRadius: 20
  },
  bar: {
    borderTopLeftRadius: 20,
    borderBottomLeftRadius: 20,
    backgroundColor: "#E95A58"
  }
})(LinearProgress);

var FranchiseProjectSingle = function FranchiseProjectSingle(props) {
  // console.log("FranchiseProjectSingle props", props);
  var project = props.project,
      saveTask = props.saveTask,
      createAfterTask = props.createAfterTask,
      createInsideTask = props.createInsideTask,
      deleteProject = props.deleteProject,
      editTask = props.editTask,
      deleteTask = props.deleteTask,
      tasksCollapse = props.tasksCollapse,
      translation = props.translation,
      invoices = props.invoices,
      notificationToOpen = props.notificationToOpen;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      notification = _useState2[0],
      setNotification = _useState2[1];

  var classes = useStyles();

  var _useState3 = useState("info"),
      _useState4 = _slicedToArray(_useState3, 2),
      valueTabs = _useState4[0],
      setValueTabs = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      taskSelected = _useState6[0],
      setTaskSelected = _useState6[1];

  var _useState7 = useState(null),
      _useState8 = _slicedToArray(_useState7, 2),
      task = _useState8[0],
      setEditTask = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      parent = _useState10[0],
      setParent = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      settingsCollapse = _useState12[0],
      setSettingsCollapse = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      editProject = _useState14[0],
      setEditProject = _useState14[1];

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      openDrawer = _React$useState2[0],
      setOpenDrawer = _React$useState2[1];

  var _React$useState3 = React.useState(false),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      openAddTask = _React$useState4[0],
      setOpenAddTask = _React$useState4[1];

  var _React$useState5 = React.useState(false),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      openAddInsideTask = _React$useState6[0],
      setOpenAddInsideTask = _React$useState6[1];

  var _React$useState7 = React.useState(false),
      _React$useState8 = _slicedToArray(_React$useState7, 2),
      openEditHeading = _React$useState8[0],
      setOpenEditHeading = _React$useState8[1];

  var _React$useState9 = React.useState(false),
      _React$useState10 = _slicedToArray(_React$useState9, 2),
      openEditTask = _React$useState10[0],
      setOpenEditTask = _React$useState10[1];

  var _React$useState11 = React.useState(false),
      _React$useState12 = _slicedToArray(_React$useState11, 2),
      openDeleteProject = _React$useState12[0],
      setOpenDeleteProject = _React$useState12[1];

  var _useState15 = useState(""),
      _useState16 = _slicedToArray(_useState15, 2),
      deletedTask = _useState16[0],
      setDeleteTask = _useState16[1];

  var _useState17 = useState(false),
      _useState18 = _slicedToArray(_useState17, 2),
      openDeleteTask = _useState18[0],
      setOpenDeleteTask = _useState18[1];

  var momentDateFinalCheck = moment().add(7, "days");
  var momentDateCurrentCheck = moment();

  var toggleDrawer = function toggleDrawer() {
    if (notificationToOpen === notification && openDrawer) {
      setOpenDrawer(!openDrawer);
    } else {
      setOpenDrawer(!openDrawer);
    }
  };

  if (notificationToOpen && notificationToOpen !== notification && project && !openDrawer) {
    setNotification(notificationToOpen);
    setTaskSelected(project.phases.find(function (item) {
      return item.key === notificationToOpen;
    }));
    setOpenDrawer(true);
  }

  var handleDialogDeleteProject = function handleDialogDeleteProject() {
    setOpenDeleteProject(!openDeleteProject);
  };

  var handleButtonActionTask = function handleButtonActionTask(prevStatus, key) {
    switch (prevStatus) {
      case "pending":
        props.editStatusTask("doing", key, settingsCollapse);
        toggleDrawer();
        break;

      case "doing":
        props.editStatusTask("done", key, settingsCollapse);
        toggleDrawer();
        break;

      default:
        // console.log("status not defined", prevStatus);
        break;
    }
  };

  var handleButtonActionTaskRecurrency = function handleButtonActionTaskRecurrency(itemRecurrency, key) {
    switch (itemRecurrency.status) {
      case "pending":
        props.editStatusTaskRecurrency("doing", itemRecurrency.key, key, settingsCollapse);
        toggleDrawer();
        break;

      case "doing":
        props.editStatusTaskRecurrency("done", itemRecurrency.key, key, settingsCollapse);
        toggleDrawer();
        break;

      default:
        break;
    }
  };

  var handleEditContentTask = function handleEditContentTask(task) {
    props.editContentTask(task);
    toggleDrawer();
  };

  var handleTabs = function handleTabs(e, newValue) {
    setValueTabs(newValue);
  };

  var handleTaskSelected = function handleTaskSelected(e, task) {
    setTaskSelected(task);
    setOpenDrawer(true);
  };

  var handleEditProjectClicked = function handleEditProjectClicked() {
    setEditProject(!editProject);
  };

  var handleCollapseSelected = function handleCollapseSelected(id) {
    var auxSettingsCollapse = settingsCollapse.map(function (settings) {
      if (settings.id === id) {
        return _objectSpread(_objectSpread({}, settings), {}, {
          collapse: !settings.collapse
        });
      }

      return _objectSpread({}, settings);
    });
    setSettingsCollapse(auxSettingsCollapse);
  };

  var handleDialogFranchiseAddTask = function handleDialogFranchiseAddTask(e, task) {
    setParent(task);
    setOpenAddTask(!openAddTask);
  };

  var handleDialogFranchiseAddInsideTask = function handleDialogFranchiseAddInsideTask(e, task) {
    // console.log('parent', parent)
    // console.log('task', task)
    setParent(task);
    setOpenAddInsideTask(!openAddInsideTask);
  };

  var addInsideTask = function addInsideTask(task) {
    var dataFinal = createLogicTask(task);
    createInsideTask(dataFinal.newTask, dataFinal.nameParent, parent, uuidv1());
  };

  var addAfterTask = function addAfterTask(task) {
    // console.log('addAfterTask values', task)
    var dataFinal = createLogicTask(task);
    createAfterTask(dataFinal.newTask, parent);
  };

  var handleDialogEditHeading = function handleDialogEditHeading(e, task) {
    // console.log("handleEditHeading task", task);
    setEditTask(task);
    setOpenEditHeading(!openEditHeading);
  };

  var handleDialogEditTask = function handleDialogEditTask(e, task) {
    // console.log("handleEditTask", task);
    setEditTask(task);
    setOpenEditTask(!openEditTask);
  };

  var handleDialogDeleteTask = function handleDialogDeleteTask(e, task) {
    setDeleteTask(task);
    setOpenDeleteTask(!openDeleteTask);
  };

  var handleEditTask = function handleEditTask(task) {
    editTask(task, settingsCollapse);
  };

  var createLogicTask = function createLogicTask(task) {
    var date = task.date,
        name = task.name,
        details = task.details,
        type = task.type,
        frequency = task.frequency,
        period = task.period,
        start = task.start,
        end = task.end,
        weekdays = task.weekdays,
        monthday = task.monthday,
        repeat = task.repeat,
        extraFields = task.extraFields; // console.log("addNewTaskAfter task", task);

    var _task = {
      name: name,
      details: details,
      key: uuidv1(),
      parent: parent,
      children: [],
      lastIndex: 0,
      order: 0,
      repeat: repeat,
      date: date,
      extraFields: extraFields,
      status: "pending"
    }; //Añadir a proyecto?

    if (type === "once") {
      _task.deadline = date;
    } else if (type === "recurring") {
      // console.log("frequency", frequency);
      var recurrence = undefined;

      switch (frequency) {
        case "day":
          recurrence = moment(start).recur(end).every(period).days();
          break;

        case "week":
          var units = {};
          weekdays.forEach(function (day) {
            units[day] = true;
          });
          recurrence = moment().recur({
            start: start,
            end: end,
            rules: [{
              units: units,
              measure: "daysOfWeek"
            }]
          });
          break;

        case "month":
          recurrence = moment(start).recur(end).every(monthday).daysOfMonth();
          break;

        default:
          break;
      }

      _task.repeats = recurrence.all().map(function (repeat) {
        return {
          date: repeat.format(),
          status: "pending",
          key: uuidv1()
        };
      });
    } // console.log("task", _task);


    return {
      newTask: _task,
      nameParent: task.nameParent
    };
  };

  var getParentState = function getParentState(key) {
    var auxItem = project.phases.find(function (item) {
      return item.key === key;
    });

    if (auxItem && auxItem.parent) {
      return getParentState(auxItem.parent);
    } // console.log("final key", key);


    return key;
  }; // INITIAL


  useEffect(function () {
    if (project) {
      if (!tasksCollapse) {
        var initialSettings = [];
        project.phases.forEach(function (item) {
          // console.log("item children", item.children);
          if (item.children.length > 0) {
            var itemsChildren = item.children.map(function (_item) {
              var __itemFound = project.phases.find(function (__item) {
                return _item === __item.key;
              });

              return {
                id: __itemFound.key,
                status: __itemFound.status
              };
            });
            initialSettings.push({
              id: item.key,
              collapse: true,
              children: itemsChildren
            });
          }
        });
        setSettingsCollapse(initialSettings);
      } else {
        setSettingsCollapse(tasksCollapse);
      }
    }
  }, [project, tasksCollapse]); // TABS PROJECT

  var tabs = [{
    label: "Info",
    value: "info"
  }, {
    label: "Plan",
    value: "plan"
  }, {
    label: "Do&Check",
    value: "docheck"
  }, {
    label: "Close",
    value: "close"
  }, {
    label: "Calendar",
    value: "calendar"
  }];

  var getItemInfo = function getItemInfo(item) {
    var contentDate;
    var contentStatusDate;

    if (item.repeat) {
      var itemRecurrency = item.repeats.length > 0 ? item.repeats.find(function (_item) {
        return _item.status !== "done";
      }) || item.repeats[item.repeats.length - 1] : null;

      if (itemRecurrency) {
        contentDate = /*#__PURE__*/React.createElement("div", {
          style: {
            paddingRight: "156px",
            display: "flex",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(RotateLeftIcon, {
          style: {
            paddingRight: "8px"
          }
        }), moment(itemRecurrency.date).format("DD/MM/YYYY"));
        contentStatusDate = /*#__PURE__*/React.createElement("div", null, getTypeState(itemRecurrency.status, itemRecurrency.date));
      } else {
        contentDate = /*#__PURE__*/React.createElement("div", {
          style: {
            paddingRight: "156px",
            display: "flex",
            alignItems: "center"
          }
        });
        contentStatusDate = /*#__PURE__*/React.createElement("div", null, getTypeState(item.status, null));
      }
    } else {
      // console.log('item getItemInfo', item)
      if (item.date) {
        contentDate = /*#__PURE__*/React.createElement("div", {
          style: {
            paddingRight: "156px",
            display: "flex",
            alignItems: "center"
          }
        }, /*#__PURE__*/React.createElement(TodayIcon, {
          style: {
            paddingRight: "8px"
          }
        }), moment(item.date).format("DD/MM/YYYY"));
        contentStatusDate = /*#__PURE__*/React.createElement("div", null, getTypeState(item.status, item.date));
      } else {
        contentDate = /*#__PURE__*/React.createElement("div", {
          style: {
            paddingRight: "156px",
            display: "flex",
            alignItems: "center"
          }
        });
        contentStatusDate = /*#__PURE__*/React.createElement("div", null, getTypeState(item.status, null));
      }
    }

    return /*#__PURE__*/React.createElement(ListItemText, {
      onClick: function onClick(e) {
        handleTaskSelected(e, item);
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "1 1 auto"
      }
    }, item.name), contentDate, contentStatusDate));
  };

  var getTypeState = function getTypeState(status, date) {
    var contentButton;

    if (status === "pending" || status === "doing") {
      if (moment(date).isBetween(momentDateCurrentCheck, momentDateFinalCheck)) {
        status += "_critical";
      }

      if (momentDateCurrentCheck.isAfter(moment(date)) && status === "pending") {
        status = "out_of_date";
      } else if (momentDateCurrentCheck.isAfter(moment(date)) && status === "doing") {
        status += "_out_of_date";
      }
    }

    switch (status) {
      case "pending":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.pending,
          label: "No empezado"
        });
        break;

      case "doing":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.doing,
          label: "En proceso"
        });
        break;

      case "done":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.done,
          label: "Hecho"
        });
        break;

      case "pending_critical":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.critical,
          label: "No empezado"
        });
        break;

      case "doing_critical":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.critical,
          label: "En proceso"
        });
        break;

      case "doing_out_of_date":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.critical,
          label: "En proceso"
        });
        break;

      case "out_of_date":
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.outOfDate,
          label: "Fuera de fecha"
        });
        break;

      default:
        contentButton = /*#__PURE__*/React.createElement(Chip, {
          className: classes.pending,
          label: "No empezado"
        });
        break;
    }

    return contentButton;
  };

  var checkRecurrencyArray = function checkRecurrencyArray(tasks) {
    var numTasksCompleted = tasks.filter(function (task) {
      return task.status === "done";
    }).length;

    if (numTasksCompleted === tasks.length) {
      return true;
    } else {
      return false;
    }
  };

  var getPercentageCompleted = function getPercentageCompleted(key) {
    var itemFound = project.phases.find(function (item) {
      return item.key === key;
    });
    var itemsDone = itemFound ? itemFound.children.filter(function (_item) {
      var auxItem = project.phases.find(function (__item) {
        return __item.key === _item;
      });

      if (auxItem.repeat) {
        if (checkRecurrencyArray(auxItem.repeats)) {
          return true;
        }
      }

      return auxItem.status === "done" ? true : false;
    }).length : 0;
    var itemsTotal = itemFound ? itemFound.children.filter(function (item) {
      return project.phases.find(function (_item) {
        return _item.key === item;
      }).children.length === 0;
    }).length : 0;
    var valueTotal = itemsDone * 100 / itemsTotal;

    if (valueTotal < 50) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          position: "absolute",
          width: "150px",
          textAlign: "center",
          top: "0",
          zIndex: "1",
          color: "#000"
        }
      }, itemsDone + " / " + itemsTotal, " "), /*#__PURE__*/React.createElement(BorderLinearIncompleteProgress, {
        variant: "determinate",
        value: valueTotal,
        style: {
          width: "100%"
        }
      }));
    } else if (valueTotal <= 99) {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          position: "absolute",
          width: "150px",
          textAlign: "center",
          top: "0",
          zIndex: "1",
          color: "#000"
        }
      }, itemsDone + " / " + itemsTotal, " "), /*#__PURE__*/React.createElement(BorderLinearMediumProgress, {
        variant: "determinate",
        value: valueTotal,
        style: {
          width: "100%"
        }
      }));
    } else {
      return /*#__PURE__*/React.createElement("div", {
        style: {
          display: "flex",
          alignItems: "center",
          width: "100%"
        }
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          position: "absolute",
          width: "150px",
          textAlign: "center",
          top: "0",
          zIndex: "1",
          color: "#000"
        }
      }, itemsDone + " / " + itemsTotal, " "), /*#__PURE__*/React.createElement(BorderLinearSuccessProgress, {
        variant: "determinate",
        value: valueTotal,
        style: {
          width: "100%"
        }
      }));
    }
  };

  var rTaskRender = function rTaskRender(item,
  /*isParent,*/
  tab, lastItem) {
    var isParent;

    if (item.children.length > 0) {
      isParent = true;
    } else {
      isParent = false;
    }

    return /*#__PURE__*/React.createElement(List, {
      style: {
        paddingTop: "0"
      }
    }, /*#__PURE__*/React.createElement(Paper, {
      style: {
        marginLeft: tab * 25 + "px",
        marginBottom: isParent ? "8px" : "0",
        height: "56px",
        backgroundColor: isParent && "#b7b6b682"
      }
    }, /*#__PURE__*/React.createElement(ListItem, {
      id: item.key,
      key: item.key
    }, isParent ? editProject ? /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "row",
        width: "100%"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        cursor: "pointer",
        flex: "1 1 auto"
      },
      onClick: function onClick() {
        return handleCollapseSelected(item.key);
      }
    }, settingsCollapse.find(function (settings) {
      return settings.id === item.key;
    }) ? settingsCollapse.find(function (settings) {
      return settings.id === item.key;
    }).collapse ? /*#__PURE__*/React.createElement(ChevronRightIcon, null) : /*#__PURE__*/React.createElement(ExpandMore, null) : null, item.name), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      key: "button_edit_" + item.key,
      onClick: function onClick(e) {
        return handleDialogEditHeading(e, item);
      },
      className: classes.editButton,
      variant: "outlined"
    }, /*#__PURE__*/React.createElement(Create, null)), /*#__PURE__*/React.createElement(Button, {
      key: "button_delete_" + item.key,
      onClick: function onClick(e) {
        handleDialogDeleteTask(e, item);
      },
      style: {
        marginRight: "10px"
      },
      variant: "outlined",
      color: "secondary"
    }, /*#__PURE__*/React.createElement(Clear, null))))) : /*#__PURE__*/React.createElement(ListItemText, {
      onClick: function onClick() {
        return handleCollapseSelected(item.key);
      },
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "1 1 auto"
      }
    }, settingsCollapse.find(function (settings) {
      return settings.id === item.key;
    }) ? settingsCollapse.find(function (settings) {
      return settings.id === item.key;
    }).collapse ? /*#__PURE__*/React.createElement(ChevronRightIcon, null) : /*#__PURE__*/React.createElement(ExpandMore, null) : null, item.name), /*#__PURE__*/React.createElement("div", {
      style: {
        minWidth: "150px"
      }
    }, getPercentageCompleted(item.key)))) : editProject ? /*#__PURE__*/React.createElement(ListItemText, null, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "1 1 auto"
      }
    }, item.name), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "center"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      key: "button_edit_" + item.key,
      onClick: function onClick(e) {
        return handleDialogEditTask(e, item);
      },
      className: classes.editButton,
      variant: "outlined"
    }, /*#__PURE__*/React.createElement(Create, null)), /*#__PURE__*/React.createElement(Button, {
      key: "button_delete_" + item.key,
      onClick: function onClick(e) {
        handleDialogDeleteTask(e, item);
      },
      style: {
        marginRight: "10px"
      },
      variant: "outlined",
      color: "secondary"
    }, /*#__PURE__*/React.createElement(Clear, null))))) : getItemInfo(item))), !isParent && editProject && /*#__PURE__*/React.createElement(Paper, {
      style: {
        margin: "8px 0 8px " + (tab + 1) * 25 + "px",
        height: "56px"
      },
      className: classes.addTaskItem,
      onClick: function onClick(e) {
        return handleDialogFranchiseAddInsideTask(e, item.key);
      }
    }, /*#__PURE__*/React.createElement(ListItem, {
      id: item.key,
      key: item.key
    }, /*#__PURE__*/React.createElement(ListItemText, {
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("div", null, "A\xF1adir tarea dentro de \"", item.name, "\"")))), /*#__PURE__*/React.createElement(Collapse, {
      "in": settingsCollapse.find(function (settings) {
        return settings.id === item.key;
      }) ? settingsCollapse.find(function (settings) {
        return settings.id === item.key;
      }).collapse ? false : true : true // ? true
      // : false
      // : false

    }, item.children.map(function (_item, index, array) {
      var nextItem = project.phases.find(function (__item) {
        return __item.key === _item;
      });
      return rTaskRender(nextItem, tab + 1, array.length - 1 === index ? true : false);
    })), lastItem && editProject && /*#__PURE__*/React.createElement(Paper, {
      onClick: function onClick(e) {
        return handleDialogFranchiseAddTask(e, item.parent);
      },
      style: {
        margin: "8px 0 8px " + tab * 25 + "px",
        height: "56px"
      },
      className: classes.addTaskItem
    }, /*#__PURE__*/React.createElement(ListItem, {
      id: item.key,
      key: item.key
    }, /*#__PURE__*/React.createElement(ListItemText, {
      style: {
        cursor: "pointer"
      }
    }, /*#__PURE__*/React.createElement("div", null, "A\xF1adir tarea despu\xE9s de \"", item.name, "\"")))));
  };

  var setContentProject = function setContentProject() {
    var auxContent = [];

    switch (valueTabs) {
      case "info":
        //TODO
        auxContent.push( /*#__PURE__*/React.createElement(InfoProject, {
          project: project.infoProject,
          translation: translation ? translation.tab_project_info : null,
          contact: project.contact,
          phases: project.phases,
          invoices: project.invoices
        }));
        break;

      case "plan":
        var auxPlanContent = project.phases.find(function (item) {
          return item.key === "plan";
        });

        if (auxPlanContent.children.length > 0) {
          auxPlanContent.children.forEach(function (item, position, array) {
            auxContent.push(rTaskRender(project.phases.find(function (_item) {
              return _item.key === item;
            }), 1, array.length <= 1 ? true : position === array.length - 1 ? true : false));
          });
        } else {
          auxContent.push(editProject && /*#__PURE__*/React.createElement(Paper, {
            style: {
              margin: "8px 0 8px " + 0 * 25 + "px",
              height: "56px"
            },
            className: classes.addTaskItem,
            onClick: function onClick(e) {
              return handleDialogFranchiseAddInsideTask(e, "plan");
            }
          }, /*#__PURE__*/React.createElement(ListItem, {
            id: auxPlanContent.key,
            key: auxPlanContent.key
          }, /*#__PURE__*/React.createElement(ListItemText, {
            style: {
              cursor: "pointer"
            }
          }, /*#__PURE__*/React.createElement("div", null, "A\xF1adir tarea dentro de \"", auxPlanContent.name, "\"")))));
        }

        break;

      case "docheck":
        var auxDoCheckContent = project.phases.find(function (item) {
          return item.key === "docheck";
        });

        if (auxDoCheckContent.children.length > 0) {
          auxDoCheckContent.children.forEach(function (item, position, array) {
            auxContent.push(rTaskRender(project.phases.find(function (_item) {
              return _item.key === item;
            }), 1, array.length <= 1 ? true : position === array.length - 1 ? true : false));
          });
        } else {
          auxContent.push(editProject && /*#__PURE__*/React.createElement(Paper, {
            style: {
              margin: "8px 0 8px " + 0 * 25 + "px",
              height: "56px"
            },
            className: classes.addTaskItem,
            onClick: function onClick(e) {
              return handleDialogFranchiseAddInsideTask(e, "docheck");
            }
          }, /*#__PURE__*/React.createElement(ListItem, {
            id: auxDoCheckContent.key,
            key: auxDoCheckContent.key
          }, /*#__PURE__*/React.createElement(ListItemText, {
            style: {
              cursor: "pointer"
            }
          }, /*#__PURE__*/React.createElement("div", null, "A\xF1adir tarea dentro de \"", auxDoCheckContent.name, "\"")))));
        }

        break;

      case "close":
        var auxCloseContent = project.phases.find(function (item) {
          return item.key === "close";
        });

        if (auxCloseContent.children.length > 0) {
          auxCloseContent.children.forEach(function (item, position, array) {
            auxContent.push(rTaskRender(project.phases.find(function (_item) {
              return _item.key === item;
            }), 1, array.length <= 1 ? true : position === array.length - 1 ? true : false));
          });
        } else {
          auxContent.push(editProject && /*#__PURE__*/React.createElement(Paper, {
            style: {
              margin: "8px 0 8px " + 0 * 25 + "px",
              height: "56px"
            },
            className: classes.addTaskItem,
            onClick: function onClick(e) {
              return handleDialogFranchiseAddInsideTask(e, "close");
            }
          }, /*#__PURE__*/React.createElement(ListItem, {
            id: auxCloseContent.key,
            key: auxCloseContent.key
          }, /*#__PURE__*/React.createElement(ListItemText, {
            style: {
              cursor: "pointer"
            }
          }, /*#__PURE__*/React.createElement("div", null, "A\xF1adir tarea dentro de \"", auxCloseContent.name, "\"")))));
        }

        break;

      case "calendar":
        var events = project.phases.filter(function (event) {
          return event.children.length === 0;
        }).filter(function (event) {
          return event.date;
        }).map(function (event) {
          return _objectSpread(_objectSpread({}, event), {}, {
            start: moment(event.date).toDate(),
            end: moment(event.date).toDate(),
            title: event.name,
            allDay: true,
            state: getParentState(event.key)
          });
        }); // console.log("events to calendar", events);

        auxContent.push( /*#__PURE__*/React.createElement(Calendar, {
          variant: "projects",
          events: events,
          date: moment().local().toDate(),
          onSelectEvent: function onSelectEvent(item) {
            handleTaskSelected(null, item);
          },
          messages: translation ? translation.calendar ? translation.calendar.messages : null : null,
          onClickEventAgenda: function onClickEventAgenda(item) {
            // console.log("item clicked", item);
            handleTaskSelected(null, item.event);
          }
        }));
        break;

      default:
        break;
    }

    return auxContent;
  };

  var titles = {
    date: "Fecha límite"
  };

  var onCloseDrawer = function onCloseDrawer() {// console.log('cerrado');
  }; // const debug = () => {
  //     console.log("Pinto");
  //     debugger;
  // };


  return [/*#__PURE__*/React.createElement(Dialog, {
    "data-cy": "modal-delete-task",
    open: openDeleteTask,
    onClose: function onClose() {
      setDeleteTask("");
      handleDialogDeleteTask();
    },
    onCancel: function onCancel() {
      setDeleteTask("");
      handleDialogDeleteTask();
    },
    id: "modal-confirm-delete-task",
    title: translation ? translation.dialogs.delete_task.titles.delete_task : "Delete task",
    text: translation ? translation.dialogs.delete_task.info : "Are you sure you want to delete this task?It will be deleted all tasks inside",
    submit: translation ? translation.dialogs.delete_task.buttons["delete"] : "Delete",
    cancel: translation ? translation.dialogs.delete_task.buttons.cancel : "Cancel",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      // console.log("deletedTask", deletedTask);
      deleteTask(deletedTask);
      handleDialogDeleteTask();
    }
  }), /*#__PURE__*/React.createElement(DialogFranchiseAddTask, {
    open: openAddTask,
    variant: "add",
    task: task || "",
    translation: translation ? translation.dialogs.add_task : null,
    createTask: addAfterTask,
    onClose: handleDialogFranchiseAddTask
  }), /*#__PURE__*/React.createElement(DialogFranchiseAddTask, {
    open: openEditHeading,
    heading: true,
    variant: "edit",
    task: task,
    editTask: handleEditTask,
    translation: translation ? translation.dialogs.add_task : null,
    onClose: handleDialogEditHeading
  }), /*#__PURE__*/React.createElement(DialogFranchiseAddTask, {
    open: openEditTask,
    variant: "edit",
    task: task,
    editTask: handleEditTask,
    translation: translation ? translation.dialogs.add_task : null,
    onClose: handleDialogEditTask
  }), /*#__PURE__*/React.createElement(DialogFranchiseAddInsideTask, {
    open: openAddInsideTask,
    translation: translation ? translation.dialogs.add_inside_task : null,
    addInsideTask: addInsideTask,
    onClose: handleDialogFranchiseAddInsideTask
  }), /*#__PURE__*/React.createElement(Dialog, {
    open: openDeleteProject,
    onClose: handleDialogDeleteProject,
    id: "modal-confirm-delete-project",
    title: translation ? translation.dialogs.delete_project.titles.delete_project : "Delete project",
    text: translation ? translation.dialogs.delete_project.info : "Are you sure you want to delete this project? It will be deleted all information inside",
    submit: translation ? translation.dialogs.delete_project.buttons["delete"] : "Delete",
    buttonColorSubmit: "secondary",
    buttonVariantSubmit: "contained",
    onCancel: handleDialogDeleteProject,
    cancel: translation ? translation.dialogs.delete_project.buttons.cancel : "Cancel",
    buttonColorCancel: "secondary",
    buttonVariantCancel: "outlined",
    onSubmit: function onSubmit() {
      deleteProject();
      handleDialogDeleteProject();
    }
  }), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, taskSelected && openDrawer && /*#__PURE__*/React.createElement(TaskDetailDrawer, {
    open: openDrawer,
    toggleDrawer: toggleDrawer,
    task: taskSelected,
    saveTask: saveTask,
    onClose: onCloseDrawer,
    titles: titles,
    translation: translation ? translation.drawers.task_detail : null,
    handleButtonActionTask: handleButtonActionTask,
    handleButtonActionTaskRecurrency: handleButtonActionTaskRecurrency,
    editContentTask: handleEditContentTask
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4",
    style: {
      flex: "1 1 auto"
    }
  }, project ? project.name : "Sin nombre"), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex"
    }
  }, !editProject ? [/*#__PURE__*/React.createElement(Button, {
    className: classes.editButton,
    color: "default",
    variant: "text",
    onClick: handleEditProjectClicked
  }, /*#__PURE__*/React.createElement(Create, null)), /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    variant: "text",
    onClick: handleDialogDeleteProject
  }, /*#__PURE__*/React.createElement(Clear, null))] : [/*#__PURE__*/React.createElement(Button, {
    color: "primary",
    variant: "outlined",
    className: classes.mr30,
    disabled: true
  }, translation ? translation.buttons.saved : "Saved"), /*#__PURE__*/React.createElement(Button, {
    color: "secondary",
    variant: "contained",
    onClick: handleEditProjectClicked
  }, translation ? translation.buttons.exit_edit : "Exit")])), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      margin: "32px"
    }
  }, /*#__PURE__*/React.createElement(Tabs, {
    value: valueTabs,
    onChange: handleTabs,
    variant: "fullWidth",
    indicatorColor: "primary",
    textColor: "primary",
    contentTabs: tabs
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    style: {
      margin: "32px"
    }
  }, project && setContentProject()))];
};

export default FranchiseProjectSingle;